import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExternalBrandsService {
    /**
     * Get External Brands
     * @returns any Successful Response
     * @throws ApiError
     */
    static getExternalBrandsDoordashBrandAllGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/doordash/brand/all',
        });
    }
    /**
     * Create External Brand
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static createExternalBrandDoordashBrandCreatePost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doordash/brand/create',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete External Brand
     * @param chain
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteExternalBrandDoordashBrandDeletePost(chain) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/doordash/brand/delete',
            query: {
                'chain': chain,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
